import React, { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, BrowserRouterProps, Routes } from 'react-router-dom';
import { ProfileProvider } from '../contexts/ProfileProvider.tsx';
import { IThemeContextUpdate } from '../contexts/ThemeProvider.tsx';
import { UIProvider } from '../contexts/UIProvider.tsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

export function RootTemplate({
  children,
  browserRouterProps = {},
  themeResolver,
}: {
  browserRouterProps?: BrowserRouterProps;
  themeResolver?: () => Promise<IThemeContextUpdate>;
} & PropsWithChildren) {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <UIProvider themeResolver={themeResolver}>
          <ProfileProvider>
            <BrowserRouter {...browserRouterProps}>
              <Routes>{children}</Routes>
            </BrowserRouter>
          </ProfileProvider>
        </UIProvider>
      </QueryClientProvider>
    </>
  );
}
